var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.payType === 20)?_c('Wepay',{attrs:{"payInfo":_vm.payInfo}}):(_vm.payType === 30)?_c('Alipay',{attrs:{"payInfo":_vm.payInfo}}):(_vm.payType === 40)?_c('Lakala',{attrs:{"payInfo":_vm.payInfo}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c56c87e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/setting/applyment/edit.vue
// module id = null
// module chunks = 